import * as React from "react";
import { Container, Row, Col } from "react-bootstrap";
import  "./css/main-menu.scss"
import { FaTwitter, FaYoutube,FaLinkedin } from "react-icons/fa";
import {gsap,Linear} from "gsap"
import { AiOutlineClose } from "react-icons/ai";
import { useLocation } from '@reach/router';
import { navigate,Link } from "gatsby"



const MainMenu = ()=>{
  const location = useLocation()

 //Route Change Programatically
  const onRouteChange = (evt,routeParam)=>{
    evt.preventDefault()
    const menuTimeline = gsap.timeline()
    menuTimeline
      .to(".mainMenu",{y:"-100%",duration: 0.2})
      .to("ul.mainLinks li a",{ease:Linear.easeNone,duration:0.32,y:100,stagger: 0.15},"-=0.1")
      .to("ul.other-links li a",{ease:Linear.easeNone,duration:0.32,y:100,stagger: 0.15},)
      .to(".socials-box h6",{ease:Linear.easeNone,duration:0.1,y:100,stagger: 0.15},)
       if(routeParam){   
      setTimeout(()=>{
        navigate(`/${routeParam}/`)
       document.querySelector("html").style.overflowY="visible"

        
      },700)
    }

    else{
      setTimeout(()=>{
        navigate(`/`)
       document.querySelector("html").style.overflowY="visible"

        
      },700)
    }
  }
  const onCloseMenu = ()=>{

   


    const menuTimeline = gsap.timeline()
    
    
    
      menuTimeline
      .to(".mainMenu",{y:"-100%",duration: 0.2})
      .to("ul.mainLinks li a",{ease:Linear.easeNone,duration:0.32,y:100,stagger: 0.15},"-=0.1")
      .to("ul.other-links li a",{ease:Linear.easeNone,duration:0.32,y:100,stagger: 0.15},)
      .to(".socials-box h6",{ease:Linear.easeNone,duration:0.1,y:100,stagger: 0.15},)
      setTimeout(()=>{
      document.querySelector("html").style.overflowY="visible"
       
      },700)
    
    }

  
  
    return(
        <div className="mainMenu">
          <div className="menuHeader">
            <Container>
              <Row>
              <Col>
              <div className="menuBar" >
              <svg width="225" height="72" viewBox="0 0 225 72" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M66.3492 19.1477C64.6545 19.8492 63.8454 21.7958 64.5488 23.4944C65.2485 25.1936 67.1911 26.0013 68.8894 25.3002C70.5841 24.5984 71.3932 22.6517 70.6898 20.9532C69.9901 19.2543 68.0475 18.4455 66.3492 19.1477Z" fill="#F68521"/>
<path fillRule="evenodd" clipRule="evenodd" d="M68.8688 45.8082C67.1741 45.1031 65.2279 45.9075 64.5245 47.6056C63.8211 49.3034 64.6229 51.2505 66.3177 51.956C68.016 52.6607 69.9585 51.8563 70.6619 50.1585C71.369 48.4607 70.5635 46.513 68.8688 45.8082Z" fill="#F68521"/>
<path fillRule="evenodd" clipRule="evenodd" d="M47.4821 64.6356C45.7837 65.3374 44.9783 67.2834 45.678 68.9829C46.3778 70.6815 48.3239 71.4899 50.0186 70.788C51.717 70.0862 52.5224 68.1402 51.8227 66.441C51.1229 64.7425 49.1768 63.9341 47.4821 64.6356Z" fill="#F68521"/>
<path fillRule="evenodd" clipRule="evenodd" d="M23.4018 64.6127C21.7071 63.908 19.7645 64.712 19.0611 66.4102C18.3541 68.1076 19.1596 70.0554 20.8543 70.7605C22.549 71.4656 24.4951 70.6608 25.1985 68.9626C25.9019 67.266 25.1001 65.3178 23.4018 64.6127Z" fill="#F68521"/>
<path fillRule="evenodd" clipRule="evenodd" d="M2.05631 45.741C0.357965 46.4432 -0.447476 48.3899 0.252273 50.0888C0.952023 51.7877 2.89819 52.5953 4.59289 51.8942C6.29124 51.1924 7.09668 49.2465 6.39693 47.5468C5.69718 45.8476 3.75102 45.0399 2.05631 45.741Z" fill="#F68521"/>
<path fillRule="evenodd" clipRule="evenodd" d="M4.62652 19.0856C2.93182 18.3802 0.98564 19.1853 0.282246 20.8827C-0.421147 22.5801 0.380641 24.5275 2.07899 25.2334C3.77369 25.9381 5.71624 25.1337 6.41964 23.436C7.12667 21.7385 6.32123 19.7904 4.62652 19.0856Z" fill="#F68521"/>
<path fillRule="evenodd" clipRule="evenodd" d="M20.9249 0.252896C19.2302 0.954347 18.4212 2.90067 19.1209 4.59956C19.8243 6.2988 21.7668 7.10719 23.4615 6.40537C25.1599 5.70319 25.969 3.75723 25.2656 2.05834C24.5658 0.359098 22.6233 -0.448554 20.9249 0.252896Z" fill="#F68521"/>
<path fillRule="evenodd" clipRule="evenodd" d="M50.0874 0.281246C48.3927 -0.424584 46.4501 0.380149 45.7467 2.07794C45.0397 3.775 45.8451 5.72278 47.5398 6.42788C49.2345 7.13335 51.1807 6.32898 51.8841 4.63119C52.5875 2.9334 51.7857 0.985981 50.0874 0.281246Z" fill="#F68521"/>
<path fillRule="evenodd" clipRule="evenodd" d="M50.8413 23.8624C54.1177 23.8628 55.601 19.9023 53.3925 17.6892C51.1802 15.4768 47.226 16.9629 47.226 20.245C47.226 25.0832 41.8612 27.8558 37.5133 28.5456C36.8172 28.6562 34.3025 28.5511 33.5444 28.431C29.1965 27.7405 23.8317 24.969 23.8317 20.1293C23.8317 16.8472 19.8738 15.3618 17.6652 17.5738C15.4566 19.7873 16.9399 23.7478 20.2164 23.7475C25.049 23.7486 27.8152 29.1204 28.5077 33.4736C28.617 34.1696 28.5113 36.6929 28.391 37.4509C27.7022 41.8045 24.936 47.1767 20.1034 47.1771C16.8233 47.1771 15.34 51.1373 17.5486 53.3504C19.7608 55.5628 23.7151 54.0777 23.7151 50.7949C23.7151 45.9563 29.0798 43.1844 33.4278 42.4939C34.1239 42.3837 36.6422 42.4888 37.4003 42.6085C41.7482 43.2994 47.113 46.0713 47.113 50.9106C47.113 54.1923 51.0673 55.6781 53.2759 53.4653C55.4845 51.2519 54.0048 47.2917 50.7247 47.2924C45.8921 47.2917 43.1259 41.9191 42.437 37.5655C42.3241 36.8703 42.4297 34.347 42.55 33.5893C43.2388 29.2354 46.0087 23.8628 50.8413 23.8624Z" fill="#F68521"/>
<path fillRule="evenodd" clipRule="evenodd" d="M35.473 9.8418C32.7104 9.8418 30.4727 12.0834 30.4727 14.8472C30.4727 17.6114 32.7104 19.8526 35.473 19.8526C38.2319 19.8526 40.4696 17.6114 40.4696 14.8472C40.4696 12.0834 38.2319 9.8418 35.473 9.8418Z" fill="#F68521"/>
<path fillRule="evenodd" clipRule="evenodd" d="M56.1157 30.5156C53.3568 30.5156 51.1191 32.7561 51.1191 35.521C51.1191 38.2856 53.3568 40.5264 56.1157 40.5264C58.8783 40.5264 61.116 38.2856 61.116 35.521C61.116 32.7561 58.8783 30.5156 56.1157 30.5156Z" fill="#F68521"/>
<path fillRule="evenodd" clipRule="evenodd" d="M35.473 51.1895C32.7141 51.1895 30.4727 53.4307 30.4727 56.1949C30.4727 58.9591 32.7141 61.2004 35.473 61.2004C38.2319 61.2004 40.4696 58.9591 40.4696 56.1949C40.4696 53.4307 38.2319 51.1895 35.473 51.1895Z" fill="#F68521"/>
<path fillRule="evenodd" clipRule="evenodd" d="M14.8267 30.5156C12.0678 30.5156 9.83008 32.7569 9.83008 35.521C9.83008 38.2849 12.0678 40.5268 14.8267 40.5268C17.5893 40.5268 19.827 38.2849 19.827 35.521C19.827 32.7569 17.5893 30.5156 14.8267 30.5156Z" fill="#F68521"/>
<path d="M89.7973 25.7275V30.8256H101.379V35.3646H89.7973V40.7543H104.583V45.4598H84.3633V21.002H104.583V25.7275H89.7973Z" fill="#CBD5E4"/>
<path d="M118.909 40.7522C121.383 40.7522 123.217 40.1351 124.408 38.9015C125.604 37.6676 126.198 35.7771 126.198 33.2297C126.198 30.6827 125.604 28.7947 124.408 27.5667C123.217 26.3389 121.383 25.7247 118.909 25.7247H113.916V40.7522H118.909ZM118.909 21C123.278 21 126.518 22.0007 128.625 24.0017C130.732 26.0035 131.785 29.079 131.785 33.2297C131.785 37.3808 130.732 40.4563 128.625 42.4577C126.518 44.4591 123.278 45.4595 118.909 45.4595H108.482V21H118.909Z" fill="#CBD5E4"/>
<path d="M157.436 33.4373V45.4598H147.781C143.342 45.4598 140.048 44.4594 137.908 42.4591C135.773 40.4587 134.701 37.3814 134.701 33.2307C134.701 29.0804 135.773 26.0031 137.908 24.0027C140.048 22.0024 143.342 21.002 147.781 21.002H156.397V25.7275H147.781C145.238 25.7275 143.353 26.3388 142.125 27.5658C140.897 28.7968 140.288 30.684 140.288 33.2307C140.288 35.7778 140.897 37.669 142.125 38.904C143.353 40.135 145.238 40.7543 147.781 40.7543H152.005V33.4373H157.436Z" fill="#CBD5E4"/>
<path d="M181.915 25.5534H181.547L181.572 25.7275H167.129V30.8256H178.715V35.3646H167.129V40.7543H181.915V45.4598H161.695V21.002H181.915V25.5534Z" fill="#CBD5E4"/>
<path d="M224.068 49.7949H217.286L209.785 44.0453H196.439C193.017 44.0453 190.229 41.2552 190.229 37.829V27.2163C190.229 23.7901 193.017 21 196.439 21H215.391C218.813 21 221.601 23.7901 221.601 27.2163V37.829C221.601 39.745 220.73 41.4603 219.363 42.6008L215.456 39.6082C216.408 39.5728 217.169 38.7896 217.169 37.829V27.2163C217.169 26.2357 216.371 25.4346 215.391 25.4346H196.439C195.459 25.4346 194.657 26.2357 194.657 27.2163V37.829C194.657 38.8126 195.459 39.6107 196.439 39.6107H210.788L216.451 43.9541L224.068 49.7949Z" fill="#F68521"/>
</svg>
                {/* <img src={MainLogo} alt="logo"/> */}
                <span className="closeIcon" onClick={onCloseMenu}> <AiOutlineClose/></span  >
                 </div>
                 </Col>
                 </Row> 
                 </Container>
                   
               </div>  
           <Container>
            <Row>
             <Col md={12}>
              
              
              
              <div className="menu-content">
              
              
              <ul className="mainLinks">
                <h3>Technology</h3>
                <li>
                     
                     <a className={location.pathname === "/technology/" ? "activeLink" : null}  href={(evt)=>evt.preventDefault()} onClick={(evt)=>onRouteChange(evt,"technology")}  >
                     Products
                    </a>
                 </li>
                 <li>
                   <a  className={location.pathname === "/usecase/" ? "activeLink" : null} href={(evt)=>evt.preventDefault()} onClick={(evt)=>onRouteChange(evt,"usecase")}>
                       Use Case
                       </a>
                 </li> 
                 {/* <li>
                     <a className={location.pathname === "/" ? "activeLink" : null}  href={(evt)=>evt.preventDefault()} onClick={(evt)=>onRouteChange(evt,"")}>
                       Home
                     </a >

                 </li> */}

                <h3>Company</h3>
                
                 <li>
                     <a className={location.pathname === "/company/" ? "activeLink" : null}  href={(evt)=>evt.preventDefault()} onClick={(evt)=>onRouteChange(evt,"company")}>
                     Leadership
                     </a>
                 </li>
                                
                 <li>
                   <a  className={location.pathname === "/media/" ? "activeLink" : null} href={(evt)=>evt.preventDefault()} onClick={(evt)=>onRouteChange(evt,"media")}>
                   Newsroom
                       </a>
                 </li>
                 <li>
                 <a  className={location.pathname === "/career/" ? "activeLink" : null} href={(evt)=>evt.preventDefault()} onClick={(evt)=>onRouteChange(evt,"career")}>
                       Career
                     </a>
                 </li>
                 <h3>Resources</h3>
                 <li>
                 <a  className={location.pathname === "/blog/" ? "activeLink" : null} href={(evt)=>evt.preventDefault()} onClick={(evt)=>onRouteChange(evt,"blog")}>
                       Blog 
                       {/* <span>new</span> */}
                     </a>
                 </li>
                 <li>
                 <a  className={location.pathname === "/video/" ? "activeLink" : null} href={(evt)=>evt.preventDefault()} onClick={(evt)=>onRouteChange(evt,"video")}>
                       Videos 
                       {/* <span>new</span> */}
                     </a>
                 </li>
                 <li>
                 <a  className={location.pathname === "/contact/" ? "activeLink" : null} href={(evt)=>evt.preventDefault()} onClick={(evt)=>onRouteChange(evt,"contact")}>
                       Contact
                     </a>
                 </li>
              </ul>
              {/* <ul className="mainLinks">
                 <li>
                     <Link activeClassName="activeFtr"  onClick={(evt)=>onRouteChange(evt,"")}>
                       Home
                     </Link >

                 </li>
                 <li>
                     
                     <Link activeClassName="activeFtr" onClick={(evt)=>onRouteChange(evt,"technology")}  >
                     Technology
                    </Link>
                 </li>
                 <li>
                     <Link   activeClassName="activeFtr" onClick={(evt)=>onRouteChange(evt,"company")}>
                       Company
                     </Link>
                 </li>
                
                 <li>
                   <Link  activeClassName="activeFtr" onClick={(evt)=>onRouteChange(evt,"media")}>
                       Media
                       </Link>
                 </li>
                 <li>
                 <Link activeClassName="activeFtr" onClick={(evt)=>onRouteChange(evt,"career")}>
                       Career
                     </Link>
                 </li>
                 <li>
                 <Link activeClassName="activeFtr" onClick={(evt)=>onRouteChange(evt,"contact")}>
                       Contact
                     </Link>
                 </li>
              </ul> */}
              <ul className="other-links">
                  <li>
                     <a rel="noreferrer" href="https://www.google.com/maps/place/2550+Great+America+Way,+Santa+Clara,+CA+95054,+USA/@37.4147558,-121.9758361,17z/data=!3m1!4b1!4m5!3m4!1s0x808fc836f5842907:0x32d997e7d38e2294!8m2!3d37.4147558!4d-121.9736474" target="_blank">2550 Great America Way Suite 125 Santa Clara, CA 95054</a>
                  </li>
                  <li>
                     <a href="mailto:info@edgeq.io" rel="noreferrer">info@edgeq.io</a>
                  </li>
                   <li>
                     <div className="socials-box">
                        <div className="sc-head">
                         <h6>Keep in Touch</h6>
                         </div>
                          <ul className="social-icon-list">
                              <li>
                                  <a href="https://www.linkedin.com/company/edgeq" target="_blank" rel="noreferrer"><FaLinkedin aria-label="linkdin"/></a>
                              </li>
                              <li >
                                  <a href="https://twitter.com/edgeq_inc?lang=en" target="_blank" rel="noreferrer"><FaTwitter aria-label="twitter"/></a>
                              </li>
                              <li>
                                  <a href="https://www.youtube.com/channel/UChEG47AbYVKYw46EGhE_dcg" target="_blank" rel="noreferrer"><FaYoutube aria-label="youtube"/></a>
                              </li>
                          </ul>
                     </div>

                   </li>

              </ul>
              </div>
              
             </Col>    
            </Row>   
             </Container>  
        </div>
    )
}

export default MainMenu